import { cn } from "@omni/utils/styles";

import { RouterModal } from "@/components/General/Modal/routerModal";
import { Content } from "@/components/Product/GuaranteeNotice/components/content/content";
import { ModalType } from "@/redux/modules/value/modal/modal.types";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type GuaranteeNoticeModalProps = {
    className?: string;
};

export const GuaranteeNoticeModal = ({
    className
}: GuaranteeNoticeModalProps) => {
    const { t } = useGranite();

    return (
        <RouterModal
            className={cn(className)}
            modalType={ModalType.GuaranteeNotice}
            withFooter={false}
            size={"lg"}
            title={t("modal.guarantee-notice.title")}
        >
            <Content>
                <Content.Image />
            </Content>
        </RouterModal>
    );
};
